import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { TokenService } from '../token/token.service';
import { Location } from "@angular/common";
import { SidebarRoutes } from 'src/app/models/sidebar-routes.model';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
    rotasModel = new SidebarRoutes(this.tokenService);

    constructor(
        private router: Router,
        private location: Location,
        private tokenService: TokenService
    ) { }

    canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot): boolean | Observable<boolean> | Promise<boolean> {
        let situacao = window.localStorage.getItem("empresa_situacao_id");
        const rotaCaixaEmail = this.verificaRota(route, state) === 'caixa-email' ? true : false;
        const rotaIncidenteGlobal = this.verificaRota(route, state) === 'incidente' ? true : false;
        const nomeComponenteRota = route.data?.component as string | undefined;
        const chavePermissaoRota = route.data?.permission as string | undefined;

        if (rotaCaixaEmail) {
            this.registrarLogFluxoAuthCaixaEmail('inicio', {
                urlSolicitada: state.url,
                nomeComponenteRota,
                chavePermissaoRota,
                situacaoEmpresaId: situacao,
                possuiSituacaoEmpresaNoStorage: !!window.localStorage.getItem('empresa_situacao_id'),
                possuiToken: this.tokenService.hasToken(),
                trialExpirado: this.tokenService.hasToken() ? this.tokenService.getTrialExpirado() : null,
                tipoPerfilUsuario: this.tokenService.getTipoPerfilUsuario(),
            });
        }

        const perfilAutorizaComponente = this.rotasModel.verificaPerfilAcessaComponente(nomeComponenteRota);

        if (rotaCaixaEmail) {
            this.registrarLogFluxoAuthCaixaEmail('apos_verificacao_perfil_componente', {
                nomeComponenteRota,
                perfilAutorizaComponente,
                tipoPerfilUsuario: this.tokenService.getTipoPerfilUsuario(),
                listaChatContemComponente: this.rotasModel.componentesUserChat?.includes(
                    'ListagemCaixaEmailTicketComponent'
                ),
                listaDashboardContemComponente: this.rotasModel.componentesUserDashboard?.includes(
                    'ListagemCaixaEmailTicketComponent'
                ),
            });
        }

        if (perfilAutorizaComponente) {
            if (window.localStorage.getItem('empresa_situacao_id')) {
                if (!this.tokenService.hasToken()) {
                    if (rotaCaixaEmail) {
                        this.registrarLogFluxoAuthCaixaEmail('bloqueio_sem_token_com_situacao_empresa', {
                            urlSolicitada: state.url,
                        });
                    }
                    let actualRoute = this.location.path().substring(1).split('/');
                    if (actualRoute.length === 4 && actualRoute[3] === 'true') {
                        this.router.navigateByUrl(this.location.path().substring(1));
                        return false;
                    } else {
                        this.router.navigate(['/login']);
                        return false;
                    }
                } else {
                    if (this.tokenService.getTrialExpirado()) {
                        if (rotaCaixaEmail) {
                            this.registrarLogFluxoAuthCaixaEmail('bloqueio_trial_expirado', { urlSolicitada: state.url });
                        }
                        this.router.navigate(['/trial']);
                        return false;
                    } else if (situacao && situacao === '1') {
                        const permissaoOk =
                            !chavePermissaoRota ||
                            this.usuarioPodeAcessarRotaPorPermissao(nomeComponenteRota, chavePermissaoRota);
                        if (rotaCaixaEmail) {
                            const possuiAlgumaChavePermissaoCaixaEmail =
                                this.tokenService.checkPermissions('@VisualizarCaixaEmail') === true ||
                                this.tokenService.checkPermissions('@VisualizarChamadoPorEmail') === true;
                            this.registrarLogFluxoAuthCaixaEmail('ramo_situacao_empresa_ativa', {
                                situacaoEmpresaId: situacao,
                                chavePermissaoRota,
                                permissaoOk,
                                checagemVisualizarCaixaEmail:
                                    this.tokenService.checkPermissions('@VisualizarCaixaEmail') === true,
                                checagemVisualizarChamadoPorEmail:
                                    this.tokenService.checkPermissions('@VisualizarChamadoPorEmail') === true,
                                liberacaoSomenteChatSemChavePermissaoNoJwt:
                                    this.tokenService.getTipoPerfilUsuario() === 3 &&
                                    !possuiAlgumaChavePermissaoCaixaEmail &&
                                    nomeComponenteRota === 'ListagemCaixaEmailTicketComponent',
                            });
                        }
                        if (
                            chavePermissaoRota &&
                            !this.usuarioPodeAcessarRotaPorPermissao(nomeComponenteRota, chavePermissaoRota)
                        ) {
                            this.registrarDiagnosticoCaixaEmailRota(route, state, 'permissao_rota_negada');
                            this.router.navigate(['/not-permission', {fgi: rotaIncidenteGlobal}]);
                            return false;
                        }
                        if (rotaCaixaEmail) {
                            this.registrarLogFluxoAuthCaixaEmail('situacao_1_permissao_ok_retorno_true', {
                                situacaoEmpresaId: situacao,
                            });
                        }
                        return true;
                    } else if (situacao && situacao === '2') {
                        const permissaoOk =
                            !chavePermissaoRota ||
                            this.usuarioPodeAcessarRotaPorPermissao(nomeComponenteRota, chavePermissaoRota);
                        if (rotaCaixaEmail) {
                            this.registrarLogFluxoAuthCaixaEmail('ramo_situacao_empresa_2', {
                                situacaoEmpresaId: situacao,
                                chavePermissaoRota,
                                permissaoOk,
                            });
                        }
                        if (
                            chavePermissaoRota &&
                            !this.usuarioPodeAcessarRotaPorPermissao(nomeComponenteRota, chavePermissaoRota)
                        ) {
                            this.registrarDiagnosticoCaixaEmailRota(route, state, 'permissao_rota_negada');
                            this.router.navigate(['/not-permission', {fgi: rotaIncidenteGlobal}]);
                            return false;
                        }
                        if (rotaCaixaEmail) {
                            this.registrarLogFluxoAuthCaixaEmail('situacao_2_permissao_ok_retorno_true', {
                                situacaoEmpresaId: situacao,
                            });
                        }
                        return true;
                    } else if (situacao && situacao === '3') {
                        if (rotaCaixaEmail) {
                            this.registrarLogFluxoAuthCaixaEmail('redireciona_planos_situacao_3', {
                                situacaoEmpresaId: situacao,
                            });
                        }
                        this.router.navigate(['/user-area/plans']);
                        return false;
                    } else if (situacao && situacao === '4') {
                        const permissaoOk =
                            !chavePermissaoRota ||
                            this.usuarioPodeAcessarRotaPorPermissao(nomeComponenteRota, chavePermissaoRota);
                        if (rotaCaixaEmail) {
                            this.registrarLogFluxoAuthCaixaEmail('ramo_situacao_empresa_4', {
                                situacaoEmpresaId: situacao,
                                chavePermissaoRota,
                                permissaoOk,
                            });
                        }
                        if (
                            chavePermissaoRota &&
                            !this.usuarioPodeAcessarRotaPorPermissao(nomeComponenteRota, chavePermissaoRota)
                        ) {
                            this.registrarDiagnosticoCaixaEmailRota(route, state, 'permissao_rota_negada');
                            this.router.navigate(['/not-permission', {fgi: rotaIncidenteGlobal}]);
                            return false;
                        }
                        if (rotaCaixaEmail) {
                            this.registrarLogFluxoAuthCaixaEmail('situacao_4_permissao_ok_retorno_true', {
                                situacaoEmpresaId: situacao,
                            });
                        }
                        return true;
                    } else {
                        if (rotaCaixaEmail) {
                            this.registrarLogFluxoAuthCaixaEmail('ramo_situacao_else_fallback', {
                                situacaoEmpresaId: situacao,
                                chavePermissaoRota,
                            });
                        }
                        let actualRoute = this.location.path().substring(1).split('/');
                        if (actualRoute[0] === 'remote-access') {
                            return false;
                        }

                        if (actualRoute.length === 4 && actualRoute[3] === 'true') {
                            this.router.navigateByUrl(this.location.path().substring(1));
                            return false;
                        } else {
                            let user = this.tokenService.getUsuario();
                            let trialDays = user['empresa'].tempo_restante_trial
                            let isTrial = user['empresa'].is_trial

                            if (isTrial) {
                                if (trialDays === 0) {
                                    this.router.navigateByUrl('/trial');
                                    return false;
                                } else {
                                    this.router.navigateByUrl(this.location.path().substring(1));
                                    return false;
                                }
                            } else {
                                this.router.navigateByUrl('/dashboards');
                                return false;
                            }
                        }
                    }
                }
            } else if (!this.tokenService.hasToken()) {
                if (rotaCaixaEmail) {
                    this.registrarLogFluxoAuthCaixaEmail('bloqueio_sem_situacao_empresa_e_sem_token', {
                        urlSolicitada: state.url,
                    });
                }
                if (state.url.startsWith('/chats-list') || state.url.startsWith('/reply-message')) {
                    localStorage.setItem('redirect', state.url);
                    localStorage.setItem('refresh', 'true');
                    this.router.navigate(['/login']);
                    return false;
                } else {
                    this.router.navigate(['/login']);
                    return false;
                }
            }
            if (rotaCaixaEmail) {
                this.registrarLogFluxoAuthCaixaEmail('guard_liberou_acesso_sem_situacao_token_presente', {
                    urlSolicitada: state.url,
                    situacaoEmpresaId: situacao,
                    chavePermissaoRota,
                });
            }
            return true;
        } else {
            this.registrarDiagnosticoCaixaEmailRota(route, state, 'perfil_nao_autorizado_componente');
            this.router.navigate(['/not-permission', {fgi: rotaIncidenteGlobal}]);
            return false;
        }
    }

    private usuarioPodeAcessarRotaPorPermissao(
        nomeComponenteRota: string | undefined,
        chavePermissaoRota: string | undefined
    ): boolean {
        if (!chavePermissaoRota) {
            return true;
        }
        if (nomeComponenteRota === 'ListagemCaixaEmailTicketComponent') {
            const possuiChaveVisualizarCaixaEmail =
                this.tokenService.checkPermissions('@VisualizarCaixaEmail') === true;
            const possuiChaveVisualizarChamadoPorEmail =
                this.tokenService.checkPermissions('@VisualizarChamadoPorEmail') === true;
            if (possuiChaveVisualizarCaixaEmail || possuiChaveVisualizarChamadoPorEmail) {
                return true;
            }
            const perfilOperadorSomenteChat = this.tokenService.getTipoPerfilUsuario() === 3;
            return perfilOperadorSomenteChat;
        }
        return this.tokenService.checkPermissions(chavePermissaoRota) === true;
    }

    private verificaRota(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): string {
        const nomeComponente = route.data?.component;
        if(nomeComponente === 'ListagemCaixaEmailTicketComponent' ||
            (!!state.url && state.url.includes('mail-box-configuration'))) {
                return 'caixa-email';
        } else if(nomeComponente === 'EditarTicketComponent' &&
            (!!state.url && state.url.includes('global-incident'))) {
                return 'incidente';
        }

        return '';
    }

    private registrarLogFluxoAuthCaixaEmail(etapaFluxo: string, dados: Record<string, unknown>): void {
        console.info('[Milvus][CaixaEmail][auth]', { etapaFluxo, ...dados });
    }

    private registrarDiagnosticoCaixaEmailRota(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot,
        motivoNegacao: string
    ): void {
        const nomeComponenteRota = route.data?.component;
        const rotaCaixaEmail =
            nomeComponenteRota === 'ListagemCaixaEmailTicketComponent' ||
            (state.url && state.url.includes('mail-box-configuration'));
        if (!rotaCaixaEmail) {
            return;
        }
        const usuarioSessao = this.tokenService.getUsuario();
        const dadosBrutosToken = this.tokenService.getAllInfos();
        const chavePermissaoRota = route.data?.permission;
        const permissaoRotaOk =
            !chavePermissaoRota ||
            this.usuarioPodeAcessarRotaPorPermissao(nomeComponenteRota, chavePermissaoRota);
        let listaChavesPermissoes: string[] | null = null;
        let quantidadePermissoes = 0;
        if (dadosBrutosToken && dadosBrutosToken['permissoes']) {
            const blocoPermissoes = dadosBrutosToken['permissoes'];
            listaChavesPermissoes = (blocoPermissoes.permissoes
                ? blocoPermissoes.permissoes
                : blocoPermissoes) as string[];
            quantidadePermissoes = Array.isArray(listaChavesPermissoes) ? listaChavesPermissoes.length : 0;
        }
        const possuiPermissaoCaixaEmail = Array.isArray(listaChavesPermissoes)
            ? listaChavesPermissoes.indexOf('@VisualizarCaixaEmail') !== -1
            : false;
        const possuiPermissaoChamadoEmail = Array.isArray(listaChavesPermissoes)
            ? listaChavesPermissoes.indexOf('@VisualizarChamadoPorEmail') !== -1
            : false;
        console.warn('[Milvus][CaixaEmail] diagnostico_acesso', {
            motivoNegacao,
            situacaoEmpresaId: window.localStorage.getItem('empresa_situacao_id'),
            urlSolicitada: state.url,
            nomeComponenteRota,
            chavePermissaoRota,
            permissaoRotaOk,
            tipoPerfilUsuario: this.tokenService.getTipoPerfilUsuario(),
            perfilPodeAcessarComponenteListagem: this.rotasModel.verificaPerfilAcessaComponente(
                'ListagemCaixaEmailTicketComponent'
            ),
            usuarioResumo: usuarioSessao
                ? {
                      id: usuarioSessao.id,
                      nome: usuarioSessao.nome,
                      username: usuarioSessao.username,
                      is_apenas_chat: usuarioSessao.is_apenas_chat,
                      is_apenas_dashboard: usuarioSessao['is_apenas_dashboard'],
                      tipo_usuario_id: usuarioSessao.tipo_usuario_id,
                      forma_cobranca_id: usuarioSessao.forma_cobranca_id,
                  }
                : null,
            flagsNoToken: {
                is_apenas_chat: dadosBrutosToken?.is_apenas_chat,
                is_apenas_dashboard: dadosBrutosToken?.is_apenas_dashboard,
            },
            checagensPermissaoServico: {
                VisualizarCaixaEmail: this.tokenService.checkPermissions('@VisualizarCaixaEmail'),
                VisualizarChamadoPorEmail: this.tokenService.checkPermissions('@VisualizarChamadoPorEmail'),
            },
            listaPermissoesContem: {
                VisualizarCaixaEmail: possuiPermissaoCaixaEmail,
                VisualizarChamadoPorEmail: possuiPermissaoChamadoEmail,
            },
            quantidadePermissoesNoToken: quantidadePermissoes,
        });
    }
}